angular.module('admin.groups.detail', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'directives.serverError',
  'ui.bootstrap.dropdown',
  'services.formErrors',
  'resources.Category',
]);

angular.module('admin.groups.detail').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.groups.edit', {
      url: '/edit/:id',
      title: 'Account Groups / Details',
      views: {
        'main@': {
          template: require('./group.tpl.html'),
          controller: 'AccountGroupsDetailCtrl',
          resolve: {
            group: ["$stateParams", "adminResource", function($stateParams, adminResource) {
              return adminResource.findAccountGroup($stateParams.id);
            }],
            categories: ["adminResource", function(adminResource) {
              return adminResource.getCategoriesTree({path: '/', depth: 2});
            }]
          }
        }
      }
    });
}]);

angular.module('admin.groups.detail').controller('AccountGroupsDetailCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "group", "categories", "STATUSES", "AdminGroup", "formErrors", "growl", "localizedMessages", function($scope, $route, $location, $log, utility, adminResource, group, categories, STATUSES, AdminGroup, formErrors, growl, localizedMessages) {
    $scope.localizedMessages = localizedMessages;
    STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );
    $scope.statusModel = [];
    $scope.STATUSES = STATUSES;
    $scope.categories = categories;
    $scope.selectSettings = {
      closeList: false
    };

    // local vars
    var deserializeData = function(data){
      deserializeAccountGroup(data.record || data);
    };
    var deserializeAccountGroup = function (data){
      if (data.statuses.length && data.statuses[0] === '*') {
        data.statuses = STATUSES;
      }
      else {
        data.statuses = data.statuses.map(function (stat) {
          return _.find(STATUSES, {id: stat});
        })
      }

      data.categories = data.categories || [];
      $scope.group = data;
    };


    $scope.submit = function () {
      var data = angular.copy($scope.group);
      data.statuses = data.statuses.map(function (status) {
        $log.log('submit----------1>'+JSON.stringify(status));
        if(status){
          return status.id;  
        }        
      });
      $log.log('submit----------1>'+JSON.stringify(data));
      AdminGroup.update(data, function (result) {
        growl.info('Group saved!');
        // $location.path('/admin/groups/edit/' + result._id);
      }, formErrors.growlErrors);
    };
    $scope.delete = function (group) {
      if (!confirm('Are you sure you want to delete this group?')) {
        return;
      }
      AdminGroup.delete({id: group.id}, function (result) {
        setTimeout(function () {
          growl.info('Group removed!');
          $location.path('/admin/groups');
        }, 1000);
      }, formErrors.growlErrors);
    };

    $scope.isChecked = function (id) {
      return ~$scope.group.categories.indexOf(id) || ~$scope.group.categories.indexOf(id.toString());
    };
    $scope.selectAllStatus = function () {
      $scope.group.statuses = STATUSES;
    };
    $scope.changeStatus = function(){
      $scope.statusAlerts = [];
      if($scope.selectedStatus && $scope.selectedStatus._id) {
        if($scope.selectedStatus._id === $scope.group.status.id) {
          // status selected is the current status
          $scope.statusAlerts.push({ type: 'danger', msg: 'That is the current status.'});
        }else{
          // update status
          var data = {
            id: $scope.selectedStatus._id,
            name: $scope.selectedStatus.name
          };
          adminResource.newAccountGroupStatus($scope.group.id, data).then(function(result){
            if(result.success){
              deserializeAccountGroup(result.AccountGroup);
            }else{
              //error due to server side validation
              angular.forEach(result.errors, function(err, index){
                $scope.statusAlerts.push({ type: 'danger', msg: err});
              });
            }
          }, function(x){
            $scope.statusAlerts.push({ type: 'danger', msg: 'Error adding new status: ' + x});
          });
        }
      }else{ //no status is selected
        $scope.statusAlerts.push({ type: 'danger', msg: 'Please choose a status.'});
      }
    };
    $scope.deleteAccountGroup = function(){
      $scope.deleteAlerts =[];
      if(confirm('Are you sure?')){
        adminResource.deleteAccountGroup($scope.group.id).then(function(result){
          if(result.success){
            //redirect to admin groups index page
            $location.path('/admin/groups');
          }else{
            //error due to server side validation
            angular.forEach(result.errors, function(err, index){
              $scope.deleteAlerts.push({ type: 'danger', msg: err});
            });
          }
        }, function(x){
          $scope.deleteAlerts.push({ type: 'danger', msg: 'Error deleting admin group: ' + x });
        });
      }
    };


    $scope.saveStatus = function() {
      var data = $scope.group.statuses.length === STATUSES.length ? ['*'] : $scope.group.statuses;
      adminResource.saveAccountGroupStatus($scope.group.id, data).then(function (result) {
        if(result.success){
          //deserializeAccountGroup(result.AccountGroup);
          $scope.statusAlerts.push({type: 'info', msg: 'Changes have been saved.'});
        }else{
          //error due to server side validation
          angular.forEach(result.errors, function(err, index){
            $scope.statusAlerts.push({ type: 'danger', msg: err});
          });
        }
      }, function(x){
        $scope.statusAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
      });
    };

    $scope.toggleNode = function(node) {
      var modelValue = node.$nodeScope.$modelValue;
      var pathLength = modelValue.path.split('/').filter(Boolean).length;
      var objPath = 'children' + (new Array(pathLength).join('.[0].children'));
      var children = {};

      adminResource.getCategoriesTree({path: modelValue.path, depth: 2}).then(function(result) {
        if (!result.length) {
          return;
        }

        result = result[0];

        modelValue.children = _.get(result, objPath);
        node.toggle();
      });
    };

    var categorySelection = function(children){
      for (var i = 0; i < children.length; i++) {
        $log.log('categorySelection---------->'+JSON.stringify(children[i]));
        $scope.group.categories.push(children[i].id.toString());
        if(children[i].children.length > 0){
          categorySelection(children[i].children);
        }
      }
    };
    var categoryDeSelection = function(children){
      for (var i = 0; i < children.length; i++) {
        $scope.group.categories.splice($scope.group.categories.indexOf(children[i].id.toString()), 1);
        if(children[i].children.length > 0){
          categoryDeSelection(children[i].children);
        }
      }
    };

    $scope.toggleCategorySelection = function(categories) {
      var idx = $scope.group.categories.indexOf(categories.id.toString());
      $log.log('');
      if (idx > -1) {
        $scope.group.categories.splice(idx, 1);
        if(categories.children.length > 0){
           categoryDeSelection(categories.children);
        }
      }
      else {
        $scope.group.categories.push(categories.id.toString());
        if(categories.children.length > 0){
           categorySelection(categories.children);
        }
      }      
    };

    $scope.saveCategories = function() {
      adminResource.saveAccountGroupCategories($scope.group.id, $scope.group.categories).then(function (result) {
        if(result.success){
          $scope.categoryAlerts.push({type: 'info', msg: 'Changes have been saved.'});
        }else{
          //error due to server side validation
          angular.forEach(result.errors, function(err, index){
            $scope.categoryAlerts.push({ type: 'danger', msg: err});
          });
        }
      }, function(x){
        $scope.categoryAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
      });
    };

    //initialize
    deserializeData(group);
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/groups/group.js